import { combineReducers } from "redux";
import { SEARCH_ADD_RECENT, SearchAddRecentAction } from "./actions";
import { SearchState } from "./types";

const maxRecent = 5;

const recent = (
  state: string[] = [],
  action: SearchAddRecentAction
): string[] => {
  switch (action.type) {
    case SEARCH_ADD_RECENT:
      if (
        action.query &&
        !state.some((s) => s.toLowerCase() === action.query.toLowerCase())
      ) {
        return [action.query, ...state].slice(0, maxRecent);
      } else {
        return state;
      }
    default:
      return state;
  }
};

export default combineReducers<SearchState>({
  recent,
});
